import React from "react";
import styled from "styled-components";


export default styled.span`
    line-height: 29px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: rgb(136 136 136);
    height: 61px;
    padding: 15px;
    box-sizing: border-box;

    flex: 0 1 auto;
    white-space: nowrap;
    font-weight: 700;

    i {
        margin-right: 10px;
    }
`;
